import {
  RechargeCommissionRuleV2,
  RechargeCommissionRuleV2Item,
} from '../invitation.type';
import {getAgentCommissionRuleGroup} from './commission-rule.utils';

export interface RechargeCommissionDisplayItem
  extends RechargeCommissionRuleV2Item {
  displayDeposit: string;
}

const defaultCommissionLevels = [1, 2, 3];

export const getRechargeCommissionLevels = (
  list: RechargeCommissionRuleV2Item[],
) => {
  const levelSet = new Set<number>(defaultCommissionLevels);

  list.forEach(item => {
    Object.keys(item).forEach(key => {
      const matched = key.match(/^level(\d+)Rate$/);
      if (matched && item[key as `level${number}Rate`]) {
        levelSet.add(Number(matched[1]));
      }
    });
  });

  return Array.from(levelSet).sort((a, b) => a - b);
};

export const getRechargeCommissionDisplayList = (
  ruleGroups: RechargeCommissionRuleV2[] | undefined,
  agentLevel: number | undefined,
): RechargeCommissionDisplayItem[] => {
  const group = getAgentCommissionRuleGroup(ruleGroups, agentLevel);
  if (!group?.list?.length) {
    return [];
  }

  return group.list.map(item => ({
    ...item,
    displayDeposit: item.subDepositAmount,
  }));
};
